import TYPES from './types';
import { apiClientWithToken, downloadExcelFile } from '../services/backend';
import fileDownload from 'js-file-download';

export const fetchOrganizerUserList = (filter) => {
    return async (dispatch) => {
        try {
            
            const res = await apiClientWithToken().get(
                '/users/list', { params: { ...filter, role: 'ROLE_ORGANIZADOR' } }
            );

            const { ok, result: { data } } = res.data;

            if (ok) {
                return { ok: true, data: data }
            } else {
                return { ok: false, message: data.message };
            }

        } catch (error) {
            console.log(error);
            return { ok: false, message: 'message-server-error' }
        }
    };
};

export const fetchStudentUserList = (filter) => {
    return async (dispatch) => {
        try {
            
            const res = await apiClientWithToken().get(
                '/users/list', { params: { ...filter, role: 'ROLE_ALUMNO' } }
            );

            const { ok, result: { data } } = res.data;

            if (ok) {
                return { ok: true, data: data }
            } else {
                return { ok: false, message: data.message };
            }

        } catch (error) {
            console.log(error);
            return { ok: false, message: 'message-server-error' }
        }
    };
};

export const fetchUserList = (filter) => {
    return async (dispatch) => {
        try {
            
            const res = await apiClientWithToken().get(
                '/users/list', { params: { ...filter } }
            );

            const { ok, result: { data } } = res.data;

            if (ok) {
                return { ok: true, data: data }
            } else {
                return { ok: false, message: data.message };
            }

        } catch (error) {
            console.log(error);
            return { ok: false, message: 'message-server-error' }
        }
    };
};

export const fetchUsers = (filter) => {
    return async (dispatch) => {
        try {
            
            const res = await apiClientWithToken().get(
                '/users', { params: { ...filter } }
            );

            const { ok, result: { data } } = res.data;

            if (ok) {
                dispatch(setUsers(data));
                return { ok: true, message: data.message }
            } else {
                return { ok: false, message: data.message };
            }

        } catch (error) {
            console.log(error);
            return { ok: false, message: 'message-server-error' }
        }
    };
};

const setUsers = (data) => ({
   type: TYPES.SET_USERS, payload: data
});

export const downloadExcel = (filter) => {
    return async () => {
        try {

            const res = await downloadExcelFile('/users/excel', 'usuarios.xlsx', filter, {
                username: 'Users',
                email: 'Users',
                active: 'Users'
            });
            const blob = await res.blob();
            fileDownload(blob, 'usuarios.xlsx');

            return { ok: true };
    
        } catch (error) {
            console.log(error);
            return { ok: false, message: 'message-server-error' };
        }
    };
};

export const selectUser = (data) => ({
    type: TYPES.SELECT_USER, payload: data
});

export const setUserFilter = (filter) => ({
    type: TYPES.SET_USER_FILTER, payload: filter
});

export const deleteUser = (id) => {
    return async () => {
        try {
            
            const res = await apiClientWithToken().delete(
                `/users/${id}`
            );

            const { ok, result: { data } } = res.data;

            if (ok) {
                return { ok: true, message: data.message };
            } else {
                return { ok: false, message: data.message };
            }

        } catch(error) {
            console.log(error);
            return { ok: false, message: 'message-server-error' };
        }
    };
};

export const sendUser = (user) => {
    return async () => {
        try {
            let res;

            if (user.Users.id) {
                res = await apiClientWithToken().put(
                    `/users/${user.Users.id}`,
                    user
                );
            } else {
                res = await apiClientWithToken().post(
                    '/users', user
                );
            }
            
            const { ok, result: { data } } = res.data;

            if (ok) {
                return { ok: true, message: data };
            } else {
                return { ok: false, message: data.message };
            }

        } catch(error) {
            console.log(error);
            return { ok: false, message: 'message-server-error' };
        }
    };
};